var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'is-unknown': _vm.isUnknown }},[_vm._v("\n\t"+_vm._s(_vm.formattedValue)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }